import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './App.css';
import VideoCanvas from './VideoCanvas';
import VideoStreamComponent from './VideoStreamComponent';
import VideoStreamDialog from '../cards/VideoStreamDialog';

import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    Button, 
    Grid, 
    Typography,
    Box,
    TextField,
    CircularProgress
  } from '@mui/material';

  import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DescriptionIcon from '@mui/icons-material/Description';
import StreamStatsPanel from './StreamStatsPanel';
import {Areaconfig} from '../../Areaconfig';


import { Alert, LinearProgress } from '@mui/material';

const AREAS = {
   "Dhori":"Dhori",
   "Giridih":"Giridih",
   "Piparwar":"Piparwar",
   "Hazaribagh":"Hazaribagh",
   "Amrapali":"Amrapali",
   "NK":"NK",
   "Rajhara":"Rajhara",
   "BarkaSayal":"BarkaSayal",
   "Argada":"Argada",
   "Kathara":"Kathara",
   "Rajrappa":"Rajrappa",
   "Kuju":"Kuju",   
   "BnK":"Bnk",
   "Magadh":"Magadh",
  };

const LOCATIONS = {
    "Dhori": [
       
       "AMLO CHECKPOST WB 01 (RD1610 )",
  "AMLO SIDING WB 2 (RD1609)",
  "Amlo CP WB 3 (RD1612)",
  "KP Siding (RD1603)",
  "OLD AMLO CHECKPOST EXIT (CP1232)",
  "Tarmi Siding WB 02 (RD1602)"
    ],
    "Giridih":[
        "GIRIDIH CHECKPOST EXIT (CP1512)",
        "Road WB no 2 NEAR CP (RD1002)",
        "Road WB No 3 (RD1003)",
        "GIRIDIH CHECKPOST ENTRY (CP1511)"
    ],
    "Piparwar":[
        "Ashoka Road WB 08 (RD1708 )",
    "Ashoka Road WB 03 (RD1703 )",
    "Ashoka WB 07 (RD1707 )",
    "CHP WB 11 (RD1740 )",
    "ASHOKA WB 09 (RD1709 )",
    "RCM ROAD WB-11 (RD1711 )",
    "ASHOKA ROAD WB 14 (RD1714 )",
    "Ashoka Road WB 13 (RD1713 )",
    "ASHOKA ROAD WB 12 (RD1712 )",
    "Ashoka Road WB 16 (RD1716 )",
    "CHP WB 02 (RD1730 )",
    "CHP WB 10 (RD0101 )",
    "BS WB 01 (RD1723 )",
    "Ashoka Rajdhar Checkpost EXIT (CP1332 )",
    "Ashoka Rajdhar Checkpost Entry (Ashoka Rajdhar Checkpost Entry (CP1331 ) )",
    "Amarpali to CHP CPP checkpost ENTRY (CP1341 )",
    "Amarpali to CHP CPP checkpost EXIT (CP1342 )",
    "CHP checkpost near road wb12 ENTRY (CP1321 )",
    "CHP checkpost near road wb12 EXIT (CP1322 )",
    "GOLAMBAR CHECKPOST ENTRY (CP1311 )",
    "GOLAMBAR CHECKPOST EXIT (CP1312 )",
    "RCM RAIL OUT",
    "Lions  Club",
    "ASHOKA WORKSHOP -2",
    "Ashoka Wb 13 Out",
    "Ashoka Wb 13 In",
    "Hospital Main Gate",
    "Doctor Waiting ",
    "Ward",
    "Sister Out",
    "Camera In",
    "Camera Out",
    "Ashoka Wb 08 Out",
    "Ashoka Wb 08 In",
    "CHP Wb 01 OUT",
    "CHP Wb 01 IN",
    "CHP Wb 02 IN",
    "CHP Wb 02 Out",
    "CHP Wb 10 In",
    "CHP Wb 10 Out",
    "Ashoka Wb 12 Out",
    "Ashoka Wb 12 In",
    "Gm Office Control room Side Gate",
    "Gm Office Control room Earting",
    "Gm Office Control room Ent",
    "Gm Office Control Room Back",
    "Ray Colliery",
    "ASHOKA WB 03 IN",
    "ASHOKA WB 03 OUT",
    "ASHOKA WB 16 OUT",
    "ASHOKA WB 16 IN",
    "Unknown",
    "CHP CONTROL ROOM PTZ",
    "CHP CONTROL ROOM ",
    "CHP PO OFFICE",
    "CHP GATE",
    "Silo",
    "CHP Control Room",
    "CHP Wb 11 out",
    "CHP Wb 11 in",
    "CHP COAL PIT NEAR 1104",
    "Survey",
    "Inside Room",
    "Towards PO Room",
    "Sampling Room Out",
    "PPR PO ROAD",
    "Rajdhar Siding Towards WB",
    "Rajdhar Siding Towards Siding",
    "Rajdhar Siding BACK",
    "Rajdhar Siding CISF CHECK POST",
    "Rajdhar Morcha 1",
    "Rajhdhar RL WB",
    "Rajdhar Morcha 2 Coal Stock",
    "BACHRA MAGZINE ROOM",
    "MAGZINE GATE 2",
    "Amrapali Checkpost",
    "GM OFFICE MAIN GATE OUT",
    "GM OFFICE MAIN GATE IN",
    "GM UNIT Entrance",
    "TO ENT",
    "Panchwati"
    ],
    "Hazaribagh":[
      "45 KANTA CHECKPOST",
  "CHARHI SIDING ROAD WB (RD1418 )",
  "Chainpur Siding Weighbridge (RD1404 )",
  "Coal Stock 2",
  "ELECTRONIC ROAD WB 1 (RD1401 )",
  "IPC",
  "JHARKHAND OC WB 2 (RD1415 )",
  "JOCP Control Room",
  "JOCP Diesel Point",
  "JOCP Pit Office",
  "JOCP WB3",
  "KEDLA WASHERY CHECKPOST ENTRY (CP1021 )",
  "KEDLA WASHERY CHECKPOST ENTRY (CP1022 )",
  "Kedla Washery BRO WB",
  "Kedla Washery BRO WB-2 (RD1402 )",
  "Kedla Washery DDU",
  "Kedla Washery Mart Room",
  "Kedla Washery PO Office",
  "Kedla Washery Road Sale IN",
  "Kedla Washery Road Sale WB",
  "Kedla Washery Road Sale WB-3 (RD1403 )",
  "Kedla Washery Security Room",
  "Kedla Washery Slurry Pond",
  "Kedla Washery Store",
  "PAREJ ENTRY (CP1005 )",
  "PAREJ EXIT (CP1006 )",
  "Parej WB2 (RD1410 )",
  "Road Sale WB",
  "TAPIN NORTH ROAD SALE WB 2 (RD1411 )",
  "TAPIN NORTH WB 01 (RD1414 )",
  "TAPIN SOUTH WB 01 (RD1406 )",
  "Tapin North Biometric",
  "Tapin North Checkpost Entry (CP1003 )",
  "Tapin North Checkpost Entry (CP1004 )",
  "Tapin North Coal Stock",
  "Tapin North PO Office",
  "Tapin North Workshop",
  "Tapin south checkpost EXIT (CP1002 )",
  "Unknown"
    ],
    "Amrapali":[
        "Check Post No 01 ENTRY LANE-1 (CP0711)",
        "Check Post No 01 EXIT LANE - 1 (CP0712)",
        "Check Post No 01 ENTRY LANE-2 (CP0713)",
        "Check Post No 05 ENTRY LANE - 1 (CP0753)",
        "Check Post No 05 ENTRY LANE - 2 (CP0751)",
        "Check Post No 05 EXIT LANE - 1 (CP0752)",
        "Check Post No 05 EXIT LANE - 2 (CP0754)",
        "Amrapali CP 6 Entry (CP0761)",
        "Amrapali CP 6 Exit (CP0762)",
        "WB No 01 (RD1101)",
        "WB No 02 (RD1102)",
        "WB No 04 (RD1104)",
        "WB No 06 (RD1106)",
        "WB No 07 (RD1107)",
        "WB No 10 (RD1110)",
        "WB NO 12 (RD1112)",
        "WB No 18 (RD1118)",
        "WB NO 19 (RD1119)",
        "WB No 20 (RD1120)",
        "WB No 21 (RD1121)",
        "WB No 24 (RD1124)",
        "WB NO 25 (RD1125)"
    ],
    "NK":[
        
    "CHURI ROAD WB (RD0601 )",
    "Dakra OCP Checkpost Entry (CP0353 )",
    "Dakra OCP Checkpost Exit (CP0354 )",
    "Dakra WB 02 (RD0609 )",
    "Dakra WB No 1 (RD0608 )",
    "KDH CHECKPOST ENTRY (CP0351 )",
    "KDH CHECKPOST EXIT (CP0352 )",
    "KDH ROAD WB No 2 (RD0606 )",
    "KDH WB 03 (RD0607 )",
    "Purnadih WB 01 (RD0602 )",
    "Purnadih WB 2 (RD0603 )",
    "Rohini Weighbridge 1 (RD0610 )",
    "Rohini Weighbridge 2 (RD0611 )"
    ],
    "Rajhara":[
        "Rajhara Entry (CP0811)",
        "WB No 3 (RD1203)",
        "Rajhara Exit (CP0812)",
        "WB No 1 (RD1201)",
        "WB No 2 (RD1202)"
    ],
    "BarkaSayal":[
       "BHURKUNDA MINE B 50MT (RD0310 )",
        "BIRSA 100 RLY SIDING WEIGHBRIDGE (RD0319 )",
        "BIRSA HESABEDA 50TON WEIGHBRIDGE (RD0308 )",
        "BURKUNDA ENTRY CHECK POST (CP3021 )",
        "BURKUNDA EXIT CHECK POST (CP3022 )",
        "KK MORE 50 MT ROAD WEIGHBRIDGE (RD0303)",
        "NEW BIRSA CHECKPOST ENTRY (CP0111 )",
        "NEW BIRSA CHECKPOST EXIT (CP0112 )",
        "New Birsa 60 TON WB (RD0307 )",
        "POTANGA ROAD WEIGHBRIDGE (RD0301)",
        "PSME ENPSME ENTRY (CP0121)",
        "PSME ENTRY (CP0121)",
        "PSME EXIT (CP0122)",
        "Potanga Checkpost (CP0125 )",
        "Potanga Checkpost Exit (CP0126 )",
        "SAUNDA B 60 MT WB (RD0305 )",
        "SAYAL D 100MT WB (RD0311 )",
        "SAYAL D 100MT WB (RD0311)",
        "Saunda 50Mt New (RD0304 )",
        "Unknown",
        "Urimari hesabeda road WB (RD0302 )"
    ],
   

    "Argada": [

       "AKC",
  "ARGADA AREA RELIGARA WB 60 MT (RD0402 )",
  "ARGADA SIRKA ROAD WB (RD0403 )",
  "Argada Cash Office",
  "Argada Sub-station",
  "CP No. 1 (Sadhu More)",
  "Checkpost - GiddiA",
  "Coal Stock Near PO Office - Giddi C",
  "E&M W/shop",
  "Excavation Workshop",
  "GIDDI C 60 MT ELECTRONIC ROAD WB (RD0401 )",
  "GM Unit",
  "GVTC",
  "Giddi A 60 MT (RD0405 )",
  "Giddi A Coal Stock",
  "Giddi A ENTRY GATE (CP3051 )",
  "Giddi A EXIT GATE (CP3052 )",
  "Giddi A Mine Entry Exit",
  "Giddi A WB",
  "Giddi C Checkpost",
  "Giddi C Coal Stock",
  "Giddi C DDU",
  "Giddi C ENTRY GATE (CP3053 )",
  "Giddi C EXIT GATE (CP3054 )",
  "Giddi C Magzine",
  "Giddi C WB",
  "Giddi Washery PO",
  "Junction (Religara)",
  "MTK Office",
  "MTK Office - Giddi A",
  "MTK Room Giddi C",
  "Magzine - Giddi A",
  "Manager office - Giddi A",
  "New Checkpost Religara",
  "OCP Checkpost No. 2+Dumper Yard",
  "PO Office Control Room - Giddi C",
  "PO Office Giddi A",
  "PO Office Giddi C",
  "Religara  100MT WB",
  "Religara 100 Mt (RD0406 )",
  "Religara 60 MT WB",
  "Rest Shelter Giddi C",
  "SIRKA ENTRY GATE (CP3005 )",
  "SIRKA EXIT GATE (CP3006 )",
  "Sirka Dispensary",
  "Sirka Magazine",
  "Sirka New Coal Stock",
  "Sirka PO Office",
  "Sirka Unit Store",
  "Tongi Sub Station",
  "Unit Store Giddi C",
  "Unknown",
  "WB+Coal Stock near Pump House",
  "WTP+ Pokharia",
  "Workshop + DDU (Giddi A)"
    ],

    "Kathara":[
        "GVP Checkpoint WB Outside",
  "GVP Checkpost WB Inside",
  "GVP Colliery WB Inside",
  "GVP Colliery WB Outside",
  "Govindpur Checkpost",
  "JRD Diesel Pump",
  "JRD Excavation Workshop",
  "JRD Pit Office CHP Entry",
  "JRD Pit Office CHP Exit",
  "JRD Portable Cabin",
  "JRD WB Checkpost 1",
  "KTA Regional Store",
  "Swang Magzine",
  "Swang PO Office",
  "Unknown",
  "Zero Point WB Inside"
    ],

    "Rajrappa":[
        "Administrative Building",
        "Central Dispatch",
        "Check-Post III",
        "Electronic Road WB Near Check-Post III (RD1503)",
        "Electronic Road WB ROCP (RD1504)",
        "Electronic Road WB ROCP (RD1505)",
        "Rajrappa ENTRY Gate (CP1101)",
        "Rajrappa EXIT Gate (CP1102)",
        "Unknown"
    ],
    "Kuju":[
       "ELECTRONIC ROAD WB (RD1306 )",
  "KARMA ENTRY GATE (CP3102 )",
  "KARMA EXIT GATE (CP3103 )",
  "KUJU NEW SIDING CHECKPOST ENTRY (CP0921 )",
  "KUJU NEW SIDING CHECKPOST EXIT (CP0922 )",
  "KUJU NEW SIDING WEIGHBRIDGE 02 (RD1304 )",
  "Karma Internal WB 2 (RD1307 )",
  "SARUBERA ENTRY GATE (CP3108 )",
  "SARUBERA EXIT GATE (SARUBERA EXIT GATE (CP3109 ) )",
  "SARUBERA OC WB (RD1309 )",
  "TOPA CHECKPOST ENTRY (CP0911 )",
  "TOPA CHECKPOST EXIT (CP0912 )",
  "TOPA OCP WEIGHBRIDGE 2 (RD1301 )",
  "Topa COLLIERY ROAD WEIGHBRIDGE 1 (RD1302 )"
    ],
    "BnK":[
        "Bokaro Hospital",
        "Bokaro Workshop",
        "Bokaro po",
        "BokaroVTC",
        "DD MINES",
        "DG SET",
        "GM Office",
        "JRD Store / Kargali WS",
        "Jarndih siding",
        "KMP PO",
        "KMP Substation",
        "KMP WB 1",
        "KMP WB 2",
        "KMP WB 3",
        "KMP WB 4",
        "KMP WB 5",
        "KMP Workshop",
        "Kargali PO",
        "Kargali Pit",
        "Karo Checkpoint",
        "Karo PO",
        "Karo Siding",
        "Karo Stock PTZ",
        "Karo WB 1",
        "Karo WB 2",
        "Karo WB 3",
        "Karo WB 4",
        "Karo WB 5",
        "Karo WB 6",
        "Karo WB 7",
        "Karo WB 9",
        "Karo pit & view point",
        "Kmp Railway Siding",
        "Konar PTZ",
        "Konar Road WB",
        "MRSS",
        "Phusro rail wb",
        "Reg.Store",
        "Rest House",
        "Washery Store",
        "Washery store",
        "Water Filter",
        "kmp  CCL Checkpost",
        "krg washery MTK",
        "krg washery PO OFFICE"
    ],
    "Magadh":[
        "MS Areas Checkpost 11 - Entry (CP0621)",
        "MS Area Checkpost 11 - Entry/Exit (CP0622)",
        "MS Area Checkpost 11 - Exit (CP0623)",
        "MS Areas Checkpost 1 - Entry (CP0651)",
        "Magadh Checkpost 1 - Exit (CP0652)",
        "WB 5 (RD1152)",
        "WB 6 (RD1153)",
        "WB 7 Kundi (RD1154)",
        "WB 9 (RD1155)",
        "10 No WB Tilaiyatand (RD1156)",
        "WB11 (RD1157)",
        "WB 13 CHAMATU (RD1159)",
        "WB 14 ARA (RD1160)",
        "WB 15 Chamatu (RD1161)",
        "WB 16 Chamatu (RD1162)",
        "WB 17 Chamatu (RD1163)",
        "WB 18 Chamatu (RD1164)",
        "WB 20 Chamatu (RD1166)",
        "WB 21 Ara (RD1167)",
        "WB 22 (RD1168)",
        "WB 23 Chamatu (RD1169)"
    ]
  };
  


 const BASE_URL = {
    "Dhori": "https://202.140.131.86:8890",
    "Giridih": "https://202.140.131.82:8890",
    "Piparwar": "https://202.140.131.94:8890",
    "Hazaribagh": "https://202.140.131.114:8890",
    "Amrapali": "https://202.140.131.85:8890",
    "NK":"https://202.140.131.98:8890",
    "BarkaSayal":"https://202.140.131.110:8890",
    "Argada":"https://202.140.131.118:8890",
    "Kathara":"https://202.140.131.90:8890",
    "Kuju":"https://202.140.131.122:8890",
    "BnK": "https://202.140.131.67:8890",
    "Rajrappa":"https://202.140.131.126:8890",
    "Rajhara":"https://202.140.131.102:8890"
};

const IntrusionView = ({ selectedArea: propSelectedArea, selectedCategory, selectedDetection, onBackToLive }) => {
    
    const [selectedArea, setSelectedArea] = useState(propSelectedArea);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedCameras, setSelectedCameras] = useState([]);
    const [availableLocations, setAvailableLocations] = useState([]);
    const [availableCameras, setAvailableCameras] = useState([]);
    const [startTime, setStartTime] = useState(new Date(Date.now() - 24 * 60 * 60 * 1000));
    const [endTime, setEndTime] = useState(new Date());
    const [generating, setGenerating] = useState(false);
    const [error, setError] = useState(null);
    const [selectedCamera, setSelectedCamera] = useState(''); 
    const [isStreaming, setIsStreaming] = useState(false);
    const [streamUrl, setStreamUrl] = useState('');
    const [streamStats, setStreamStats] = useState(null);
    const statsTimerRef = useRef(null);
    const [loadingCameras, setLoadingCameras] = useState(false);

    const [polygonPoints, setPolygonPoints] = useState([]);
    const [isDrawing, setIsDrawing] = useState(false);
    const [polygonComplete, setPolygonComplete] = useState(false);
    const canvasRef = useRef(null);
    const imageRef = useRef(null);
    const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (selectedArea) {
            setAvailableLocations(LOCATIONS[selectedArea] || []);
            setSelectedLocation('');
            setSelectedCameras([]);
            setAvailableCameras([]);
            setSelectedCamera('');
        }
    }, [selectedArea]);

    useEffect(() => {
        if (selectedLocation && selectedArea) {
            fetchCamerasByLocation(selectedLocation);
        } else {
            setAvailableCameras([]);
            setSelectedCamera('');
        }
    }, [selectedLocation, selectedArea]);

    const fetchCamerasByLocation = async (location) => {
        setLoadingCameras(true);
        setError(null);
        
        try {
            let cameras = [];
            
            for (let areaIndex = 0; areaIndex < Areaconfig.length; areaIndex++) {
                const areaData = Areaconfig[areaIndex];
                if (areaData[location]) {
                    const cameraIPs = areaData[location];
                    const areaCameras = cameraIPs.map((ip, index) => ({
                        ip: ip,
                        name: `Camera ${index + 1}`,
                        id: `${location}_${index}`,
                        status: 'online'
                    }));
                    cameras = [...cameras, ...areaCameras];
                    break;
                }
            }
            
            if (cameras.length > 0) {
                setAvailableCameras(cameras);
            } else {
                setAvailableCameras([]);
                setError('No cameras found for this location');
            }
            
        } catch (error) {
            console.error('Error fetching cameras:', error);
            setError('Failed to load cameras for this location');
            setAvailableCameras([]);
        } finally {
            setLoadingCameras(false);
        }
    };

    useEffect(() => {
        if (isStreaming && canvasRef.current && imageRef.current) {
            const canvas = canvasRef.current;
            const img = imageRef.current;
            
            const updateCanvasSize = () => {
                const rect = img.getBoundingClientRect();
                canvas.width = rect.width;
                canvas.height = rect.height;
                setCanvasSize({ width: rect.width, height: rect.height });
                redrawPolygon();
            };
            img.onload = updateCanvasSize;
            
            window.addEventListener('resize', updateCanvasSize);
            
            updateCanvasSize();

            return () => {
                window.removeEventListener('resize', updateCanvasSize);
            };
        }
    }, [isStreaming, streamUrl]);

    const redrawPolygon = () => {
        if (!canvasRef.current) return;
        
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        if (polygonPoints.length > 0) {
            ctx.beginPath();
            ctx.moveTo(polygonPoints[0].x, polygonPoints[0].y);
            
            for (let i = 1; i < polygonPoints.length; i++) {
                ctx.lineTo(polygonPoints[i].x, polygonPoints[i].y);
            }
            
            if (polygonComplete) {
                ctx.closePath();
            }
            
            ctx.stroke();
            
            ctx.fillStyle = '#ff0000';
            polygonPoints.forEach(point => {
                ctx.beginPath();
                ctx.arc(point.x, point.y, 4, 0, 2 * Math.PI);
                ctx.fill();
            });
        }
    };

    const handleCanvasClick = (e) => {
        if (!isDrawing || polygonComplete) return;
        
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const newPoint = { x, y };
        setPolygonPoints(prev => [...prev, newPoint]);
    };

    const handleCanvasRightClick = (e) => {
        e.preventDefault();
        if (polygonPoints.length >= 3 && isDrawing) {
            setPolygonComplete(true);
            setIsDrawing(false);
            //console.log('Polygon completed:', polygonPoints);
        }
    };

    const convertToImageCoordinates = () => {
        if (!imageRef.current || !canvasRef.current) return [];
        
        const img = imageRef.current;
        const canvas = canvasRef.current;
        
        const naturalWidth = img.naturalWidth;
        const naturalHeight = img.naturalHeight;
        
        const displayWidth = canvas.width;
        const displayHeight = canvas.height;
        
        const scaleX = naturalWidth / displayWidth;
        const scaleY = naturalHeight / displayHeight;
        
        return polygonPoints.map(point => ({
            x: Math.round(point.x * scaleX),
            y: Math.round(point.y * scaleY)
        }));
    };

    const sendPolygonToBackend = async () => {
        if (!polygonComplete || polygonPoints.length < 3) {
            alert('Please complete the polygon first');
            return;
        }
        
        const imageCoords = convertToImageCoordinates();
        
        try {
            const baseUrl = BASE_URL[selectedArea];
            const response = await axios.post(`${baseUrl}/set-intrusion-zone`, {
                camera_ip: selectedCamera,
                polygon_points: imageCoords,
                area: selectedArea,
                location: selectedLocation
            });
            
            //console.log('Polygon sent to backend:', response.data);
            alert('Intrusion zone set successfully!');
        } catch (error) {
            console.error('Error sending polygon:', error);
            alert('Failed to set intrusion zone');
        }
    };

    const startDrawing = () => {
        setIsDrawing(true);
        setPolygonPoints([]);
        setPolygonComplete(false);
    };

    const resetPolygon = () => {
        setPolygonPoints([]);
        setPolygonComplete(false);
        setIsDrawing(false);
        redrawPolygon();
    };

    useEffect(() => {
        redrawPolygon();
    }, [polygonPoints, polygonComplete]);

    const handleAreaChange = (e) => {
        const newArea = e.target.value;
        setSelectedArea(newArea);
        
        setSelectedLocation('');
        setSelectedCameras([]);
        setAvailableCameras([]);
        setSelectedCamera('');
        
        setAvailableLocations(LOCATIONS[newArea] || []);
    };

    const handleLocationChange = (e) => {
        const newLocation = e.target.value;
        setSelectedLocation(newLocation);
        setSelectedCamera('');
    };

    const handleCameraChange = (e) => {
        setSelectedCamera(e.target.value);
    };

    const startStream = async () => {
        if (!selectedCamera || !selectedArea) return;
        try {
            const baseUrl = BASE_URL[selectedArea];
            const response = await axios.post(`${baseUrl}/start-stream`, {
                camera_ip: selectedCamera
            });
            setStreamUrl(`${baseUrl}${response.data.stream_url}`);
            setIsStreaming(true);
            resetPolygon();
        } catch (error) {
            setIsStreaming(false);
            alert("Failed to start stream.");
        }
    };

    const stopStream = async () => {
        if (!isStreaming) return;

        try {
            const baseUrl = BASE_URL[selectedArea];
            if (!baseUrl) {
                alert("Invalid area selected. Please try again.");
                return;
            }
            const response = await axios.post(`${baseUrl}/stop-stream`, {
                camera_ip: selectedCamera
            });
            //console.log("Stream stopped:", response.data);
        } catch (error) {
            console.error("Error stopping stream:", error);
            alert("Failed to stop stream. Please try again.");
        } finally {
            setIsStreaming(false);
            setStreamUrl('');
            setStreamStats(null);
            resetPolygon();
            if (statsTimerRef.current) {
                clearInterval(statsTimerRef.current);
            }
        }
    };

    return (
        <Box sx={{ p: 2, borderRadius: 1 }}>
            <Typography variant="h6" gutterBottom>Define Intrusion Detection Zone</Typography>
            
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Area</InputLabel>
                        <Select
                            value={selectedArea}
                            label="Area"
                            onChange={handleAreaChange}
                            disabled={generating}
                        >
                            <MenuItem value="">
                                <em>Select Area</em>
                            </MenuItem>
                            {Object.keys(AREAS).map(area => (
                                <MenuItem key={area} value={area}>{area}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small" disabled={!selectedArea || generating}>
                        <InputLabel>Location</InputLabel>
                        <Select
                            value={selectedLocation}
                            label="Location"
                            onChange={handleLocationChange}
                        >
                            <MenuItem value="">
                                <em>Select Location</em>
                            </MenuItem>
                            {availableLocations.map(location => (
                                <MenuItem key={location} value={location}>{location}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small" disabled={!selectedLocation || generating || loadingCameras}>
                        <InputLabel>Cameras</InputLabel>
                        <Select
                            value={selectedCamera}
                            label="Camera"
                            onChange={handleCameraChange}
                        >
                            <MenuItem value="">
                                <em>{loadingCameras ? 'Loading cameras...' : 'Select Camera'}</em>
                            </MenuItem>
                            {availableCameras.map(camera => (
                                <MenuItem key={camera.ip} value={camera.ip}>
                                    {camera.name} ({camera.ip})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {loadingCameras && (
                        <LinearProgress sx={{ mt: 1 }} />
                    )}
                </Grid>
            </Grid>

            {selectedLocation && !loadingCameras && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {availableCameras.length} camera(s) available in {selectedLocation}
                </Typography>
            )}

            <div className="stream-controls" style={{ margin: '20px 0' }}>
                {!isStreaming ? (
                    <button 
                        className="start-btn" 
                        onClick={startStream} 
                        disabled={!selectedCamera}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: selectedCamera ? 'pointer' : 'not-allowed'
                        }}
                    >
                        Start Stream
                    </button>
                ) : (
                    <button 
                        className="stop-btn" 
                        onClick={stopStream}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#f44336',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Stop Stream
                    </button>
                )}
            </div>

            <div className="stream-container" style={{ 
                width: '45%', 
                height: '55%', 
                margin: 'auto', 
                position: 'relative',
                border: '2px solid #ddd',
                borderRadius: '8px',
                overflow: 'hidden'
            }}>
                {isStreaming && streamUrl ? (
                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <img
                            ref={imageRef}
                            src={streamUrl}
                            alt="Live Stream"
                            style={{ 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'contain', 
                                maxHeight: '400px',
                                display: 'block'
                            }}
                        />
                        <canvas
                            ref={canvasRef}
                            onClick={handleCanvasClick}
                            onContextMenu={handleCanvasRightClick}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                cursor: isDrawing ? 'crosshair' : 'default',
                                pointerEvents: 'auto'
                            }}
                        />
                    </div>
                ) : (
                    <div className="stream-placeholder" style={{ 
                        width: '100%', 
                        height: '300px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5'
                    }}>
                        <div className="placeholder-text" style={{ textAlign: 'center', color: '#666' }}>
                            Select a camera and click "Start Stream" to begin monitoring
                        </div>
                    </div>
                )}
            </div>

            {isStreaming && (
                <div style={{ 
                    margin: '20px auto', 
                    textAlign: 'center',
                    width: '70%'
                }}>
                    <div style={{ marginBottom: '10px' }}>
                        <button
                            onClick={startDrawing}
                            disabled={isDrawing}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: isDrawing ? '#ccc' : '#2196F3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: isDrawing ? 'not-allowed' : 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            Start Drawing Zone
                        </button>
                        
                        <button
                            onClick={resetPolygon}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#FF9800',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            Reset Zone
                        </button>
                        
                        <button
                            onClick={sendPolygonToBackend}
                            disabled={!polygonComplete}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: polygonComplete ? '#4CAF50' : '#ccc',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: polygonComplete ? 'pointer' : 'not-allowed'
                            }}
                        >
                            Save Zone
                        </button>
                    </div>
                    
                    <div style={{ fontSize: '14px', color: '#666' }}>
                        {isDrawing && (
                            <p>Click on the video to mark points. Right-click when you have at least 3 points to complete the zone.</p>
                        )}
                        {!isDrawing && !polygonComplete && (
                            <p>Click "Start Drawing Zone" to define an intrusion detection area.</p>
                        )}
                    </div>
                </div>
            )}

            <StreamStatsPanel stats={streamStats} />
            
            <Box sx={{ mt: 2 }}>
                <Button variant="outlined" onClick={onBackToLive} disabled={generating}>
                    Back to Live View
                </Button>
            </Box>
        </Box>
    );
};

export default IntrusionView;